__turbopack_context__.v({
  "asset": "HeroFullVideo-module__Du2qgq__asset",
  "cta": "HeroFullVideo-module__Du2qgq__cta",
  "mainAsset": "HeroFullVideo-module__Du2qgq__mainAsset",
  "root": "HeroFullVideo-module__Du2qgq__root",
  "sentinel": "HeroFullVideo-module__Du2qgq__sentinel",
  "text": "HeroFullVideo-module__Du2qgq__text",
  "title": "HeroFullVideo-module__Du2qgq__title",
});
